import { Link } from "react-router-dom";
import Icon from "@/components/base/Icon";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <Icon name="ri-book-open-fill" className="w-5 h-5" />
              </span>
              <span className="font-heading text-lg font-bold text-secondary-950">
                羞羞色漫
              </span>
            </div>
            <p className="mt-3 text-sm text-secondary-700 max-w-md leading-relaxed">
              羞羞色漫是面向漫画爱好者的精品在线阅读平台，汇聚最新连载与热门作品，
              提供分类浏览、章节预览、连载更新与个性化推荐，让你随时找到下一部心动漫画。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-200 text-xs text-secondary-800">
              <Icon name="ri-shield-check-line" className="w-4 h-4" />
              内容面向 18 岁以上读者，请理性阅读
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-secondary-950 mb-3">
              <Link to="/category/all" className="cursor-pointer hover:text-primary-600 transition-colors">
                漫画分类
              </Link>
            </h4>
            <ul className="grid grid-cols-2 gap-2 text-sm">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-secondary-700 cursor-pointer transition-colors hover:text-primary-600"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-secondary-950 mb-3">
              快捷入口
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <Link to="/" className="text-secondary-700 cursor-pointer transition-colors hover:text-primary-600">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-secondary-700 cursor-pointer transition-colors hover:text-primary-600">
                  搜索漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-700 cursor-pointer transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-700 cursor-pointer transition-colors hover:text-primary-600">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-600">
            © {year} 羞羞色漫 · 本站为演示站点，站内漫画数据与功能均为演示内容
          </p>
          <p className="text-xs text-secondary-600">
            仅提供内容发现与阅读体验演示，不涉及任何付费与账号体系
          </p>
        </div>
      </div>
    </footer>
  );
}